import { z } from 'zod';

export const spefcificDomainZodRule = (tlds: string[]) => {
  return z
    .string()
    .min(3, 'Domain too short! Must be at least 3 characters.')
    .max(63, 'Domain too long!')
    .transform((domain) => domain.toLowerCase())
    .transform((domain) => domain.trim())
    .refine((domain) => {
      // should be a valid domain name which can only contain letters, numbers, and hyphens. It accepts tlds as well
      return /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*$/.test(domain);
    }, 'Invalid domain name, can only contain letters, numbers, and hyphens.')
    .refine(
      (domain) => {
        return tlds.some((tld) => domain.endsWith(tld));
      },
      'Invalid domain name, must end with one of the following tlds: ' + tlds.join(', '),
    );
};
